module.exports = __webpack_public_path__ + "img/banner02.c225b76f.png";